import { IServiceFactory } from '../../common/types/service-factory';
import { IJourneyExplorerApiService, JourneyExplorerApiService } from '../services/journey-explorer-api-service';
import { ApiServiceFactoryBase } from './base/api-service-factory-base';

export class JourneyExplorerApiServiceFactory extends ApiServiceFactoryBase implements IServiceFactory<IJourneyExplorerApiService> {
	public Create(): IJourneyExplorerApiService {
		return new JourneyExplorerApiService(this.apiServiceFactory.Create(), this.appConfigService);
	}
}
